// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.View_body__NHWtA {
  padding: 0 4.782vw;
}
.View_body__NHWtA p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/common/View/View.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAEE;EACE,SAAA;AAAJ","sourcesContent":["@use \"styles/colors\";\n\n.body {\n  padding: 0 4.782vw;\n  p {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `View_body__NHWtA`
};
export default ___CSS_LOADER_EXPORT___;
